import { Injectable } from '@angular/core';
import {HttpClient} from '@angular/common/http';
import {Observable, of} from 'rxjs';
import {LoginApiService} from '../../api/login/login-api.service';

@Injectable({
  providedIn: 'root'
})
export class UserDataService {
  private data: any;

  constructor(private http: HttpClient, private loginApiService: LoginApiService) {}

  fetchData(): Observable<any> {
    try {
      const data = sessionStorage.getItem('session');
      if (data) {
        return this.loginApiService.getUserInfo();
      }
    } catch (error) {

    }

    return of();
  }

  setData(data: any): void {
    this.data = data;
  }

  getData(): any {
    return this.data;
  }
}
